function Dashboard() {
  return (
    <>
      <h2>Dashboard</h2>

      <div className="row mt-4">
        <div className="col-md-4">
          <div className="card p-3">
            <h5>Total Students</h5>
            <h2>250</h2>
          </div>
        </div>

        <div className="col-md-4">
          <div className="card p-3">
            <h5>Total Tests</h5>
            <h2>45</h2>
          </div>
        </div>

        <div className="col-md-4">
          <div className="card p-3">
            <h5>Total Revenue</h5>
            <h2>₹50,000</h2>
          </div>
        </div>
      </div>
    </>
  );
}

export default Dashboard;